import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-message-dialog',
  templateUrl: './alert-message-dialog.component.html',
  styleUrls: ['./alert-message-dialog.component.css']
})
export class AlertMessageDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<AlertMessageDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {   dialogRef.disableClose = true; }

  ngOnInit() {
  }

}
